import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './Badge.module.scss';

// ---

export const enum BadgeSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const enum BadgeColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DEFAULT = 'default',
}

export type BadgeProps = {
  size?: BadgeSize;
  color?: BadgeColor;
  text?: string;
  title?: string;
  tag?: keyof JSX.IntrinsicElements;
  className?: string;
};

export const Badge: FC<BadgeProps> = ({
  size= BadgeSize.MEDIUM,
  color = BadgeColor.SECONDARY,
  text,
  title,
  tag: Tag = 'span',
  className,
}) => {
  const badgeClassNames = classNames(styles.badge, {
    [styles.small]: size === BadgeSize.SMALL,
    [styles.medium]: size === BadgeSize.MEDIUM,
    [styles.large]: size === BadgeSize.LARGE,
    [styles.primary]: color === BadgeColor.PRIMARY,
    [styles.secondary]: color === BadgeColor.SECONDARY,
  }, className);

  return (
    <Tag className={badgeClassNames}
         title={title}>
      {text}
    </Tag>
  );
};
